<div class="container-fluid section pt-3 pb-2">
    <div class="d-flex flex-row justify-content-between mb-2 pr-3">
        <div>
            <span class="header mr-4">My blogs</span>
            <button class="btn btn-theme" [routerLink]="['/create-blog']">
                <img src="../../../../../../assets/Images/add_circle.svg"><span class="add-label ml-2">Add new</span>
            </button>
        </div>
        <div *ngIf="blogs.length" [routerLink]="['/blog-listing']">
            <span class="navigate-text mr-2">VIEW ALL</span>
            <i class="fas fa-long-arrow-alt-right arrow-icon"></i>
        </div>
    </div>
    <div *ngIf="blogs.length" class="blog-section">
        <div class="d-flex flex-row blog-row my-3 pr-2" *ngFor="let blog of blogs"
            [routerLink]="['/blog-detail', blog.postId]">
            <img *ngIf="blog.image" [src]="blog.image" class="blog-image mr-3">
            <img *ngIf="!blog.image" src="../../../../../../assets/Images/blog-not-found.png" class="blog-image mr-3">
            <div class="d-flex flex-column">
                <div class="blog-title-section">
                    <span class="title">{{blog?.title}}</span>
                </div>
                <div class="blog-sub-title-section">
                    <span class="sub-title mt-2">{{blog?.body}}</span>
                </div>
            </div>
        </div>
    </div>
    <div class="no-data" *ngIf="!blogs.length">
        <img class="align-self-center" src="../../../../../../assets/Images/NoDocuments.png" height="50" width="80"
            alt="No Blogs">
        <span>No blogs</span>
    </div>
</div>